<template>
  <a
    :href="href"
    :data-testid="testId"
    :data-active="active ? 'true' : null"
    :title="title"
    class="relative hbox items-center font-medium no-underline transition-colors"
    :class="[
      dense ? 'min-h-11 gap-2 rounded-md px-2 text-base' : 'min-h-11 gap-3 rounded-lg px-3 text-base',
      active ? activeClass : inactiveClass,
      centered ? 'lg:justify-center lg:px-0' : '',
    ]"
    @click="onClick"
  >
    <span
      v-if="active && showIndicator"
      class="absolute left-0 top-1/2 h-5 w-1 -translate-y-1/2 rounded-r bg-navy"
    ></span>
    <slot></slot>
  </a>
</template>

<script>
/*
 * NavLink — item de navegación del shell.
 *
 * Existe porque el compilador de Vue CLI 4 (vue-template-compiler) NO aplica
 * los listeners de un slot scope (v-slot de router-link) sobre elementos
 * nativos: un <a v-slot @click> queda sin listener en el navegador.
 * Este componente renderiza el <a> y maneja el click internamente.
 * Se elimina en la Fase 3 (Vue 3 + Vite no tienen el bug).
 */
export default {
  name: 'NavLink',
  props: {
    to: { type: Object, required: true },
    testId: { type: String, default: '' },
    title: { type: String, default: '' },
    active: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    showIndicator: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    activeClass: { type: String, default: 'bg-white/15 text-white' },
    inactiveClass: { type: String, default: 'text-blue-100/70 hover:bg-white/10 hover:text-white' },
  },
  emits: ['navigate'],
  computed: {
    href() {
      return this.$router.resolve(this.to).href
    },
  },
  methods: {
    onClick(event) {
      event.preventDefault()
      this.$router.push(this.to).catch(() => {})
      this.$emit('navigate')
    },
  },
}
</script>
